export const VAT_MODE = {
  EXCLUSIVE: 'exclusive',
  INCLUSIVE: 'inclusive',
};
